import React from 'react';
import { IWorkLogTabPanel } from './interfaces';
import { TabPanel } from '../../../../../components/tabs';
import { ManagedDataTable } from '../../../../../components/ManagedDataTable';
import { IManagedDataTable } from '../../../../../components/ManagedDataTable/interfaces';
import { WorkLog } from '../../../../../api/activitiesApi/interfaces';
import { useGetPlannedActivityWorkLog } from '../../../../../reactQuery/Activities/activities';
import { ROUTES } from '../../../../../routes/Routes';
import { useNavigate } from 'react-router';
import { getColumns } from './helpers';
import { EmptyPlaceholder } from '../../../../../components/EmptyPlaceholder';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useTranslation } from 'react-i18next';

export const WorkLogTabPanel: React.FC<IWorkLogTabPanel> = ({
  plannedActivityId,
  index,
  value,
}): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onRowClick = (row: WorkLog): void => {
    navigate(ROUTES.activityLog.details(row.id));
  };

  return (
    <TabPanel value={value} index={index}>
      <ManagedDataTable
        query={
          useGetPlannedActivityWorkLog as IManagedDataTable<WorkLog>['query']
        }
        extraQueryParams={{
          id: plannedActivityId,
        }}
        columns={getColumns()}
        onRowClick={onRowClick}
        searchable={false}
        initialSort={{ field: 'performedAt', sort: 'desc' }}
        emptyPlaceholder={
          <EmptyPlaceholder
            title={t('plannedActivities:details.worklog.placeholder.title')}
            subTitle={t(
              'plannedActivities:details.worklog.placeholder.subTitle'
            )}
            icon={EventBusyIcon}
          />
        }
      />
    </TabPanel>
  );
};
